var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2",staticStyle:{"height":"50vh"}},[_c('iframe',{attrs:{"height":"100%","width":"100%","src":"/publications/SE2A_PublicationPolicy_2021-03-31_final.pdf"}})])
}]

export { render, staticRenderFns }